var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-2.5 -3.5 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81818 0C0.814028 0 0 0.814028 0 1.81818V10.9091C0 11.9132 0.814028 12.7273 1.81818 12.7273H12.7273C13.7314 12.7273 14.5455 11.9132 14.5455 10.9091V1.81818C14.5455 0.814028 13.7314 0 12.7273 0H1.81818ZM5.19309 9.64205C5.19309 10.0437 5.5187 10.3693 5.92037 10.3693C6.32203 10.3693 6.64764 10.0437 6.64764 9.64205L6.64764 3.08523C6.64764 2.68357 6.32203 2.35795 5.92037 2.35795C5.5187 2.35795 5.19309 2.68357 5.19309 3.08523V9.64205ZM3.19309 10.3693C2.79143 10.3693 2.46582 10.0437 2.46582 9.64205V7.45925C2.46582 7.05759 2.79143 6.73198 3.19309 6.73198C3.59475 6.73198 3.92037 7.05759 3.92037 7.45925V9.64205C3.92037 10.0437 3.59476 10.3693 3.19309 10.3693ZM10.676 9.64205C10.676 10.0437 11.0017 10.3693 11.4033 10.3693C11.805 10.3693 12.1306 10.0437 12.1306 9.64205V7.45925C12.1306 7.05759 11.805 6.73198 11.4033 6.73198C11.0017 6.73198 10.676 7.05759 10.676 7.45925V9.64205ZM8.64764 10.3693C8.24598 10.3693 7.92037 10.0437 7.92037 9.64205V5.20317C7.92037 4.80151 8.24598 4.4759 8.64764 4.4759C9.0493 4.4759 9.37491 4.80151 9.37491 5.20317V9.64205C9.37491 10.0437 9.0493 10.3693 8.64764 10.3693Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/ExploreIcon.b232313dd68223afe661fb2d0e1ca6e6.svg";
export { ForwardRef as ReactComponent };